import type { StateCreator } from "zustand";


export interface loadingState {
  loading: boolean;
  setLoading: (loading: boolean) => void;
}

export const initialLoadingState = {
  loading: false,
}

export const loadingSlice: StateCreator<loadingState> = (set) => ({
  ...initialLoadingState,
  setLoading: (loading: boolean) => set({ loading }),
})